;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('InputRadioController', InputRadioController)

  /* @ngInject */
  function InputRadioController ($scope, Utils) {
    const api = {
      _checkForLinks
    }
    this.getApi = () => api

    activate()

    function activate () {
      _checkForLinks()
    }

    $scope.onChange = function (newValue) {
      if ($scope.change) {
        $scope.change({
          modelPropertyName: $scope.modelPropertyName,
          modelNewValue: newValue
        })
      } else {
        $scope.model = newValue
      }
    }

    function _checkForLinks () {
      const result = Utils.processTextsWithLinks([$scope.label, $scope.description])
      $scope.labelWithLinks = result[0]
      $scope.descriptionWithLinks = result[1]
    }
  }
})()
